/**
 * Centralized framework/container port mapping configuration
 * Used for both frontend and backend service preview routing
 */
export const FRAMEWORK_CONFIG = {
  // Frontend frameworks
  'react': { port: 3001, name: 'react-container-live', display: 'React' },
  'nextjs': { port: 3002, name: 'nextjs-container-live', display: 'Next.js' },
  'reactnative': { port: 3003, name: 'reactnative-container-live', display: 'React Native' },
  'angular': { port: 3004, name: 'angular-container-live', display: 'Angular' },
  'vue': { port: 3005, name: 'vue-container-live', display: 'Vue.js' },
  'jquery': { port: 3006, name: 'jquery-container-live', display: 'jQuery' },
  'aspnet-frontend': { port: 3007, name: 'aspnet-frontend-container-live', display: 'ASP.NET' },
  'docusaurus': { port: 3008, name: 'docusaurus-container-live', display: 'Docusaurus' },
  // Backend frameworks
  'node': { port: 3011, name: 'node-container-live', display: 'Node.js' },
  'go': { port: 3012, name: 'go-container-live', display: 'Go' },
  'python': { port: 3013, name: 'python-container-live', display: 'Python' },
  'java': { port: 3014, name: 'java-container-live', display: 'Java' },
  'dotnet': { port: 3015, name: 'dotnet-container-live', display: '.NET' },
  'rust': { port: 3016, name: 'rust-container-live', display: 'Rust' },
  'php': { port: 3017, name: 'php-container-live', display: 'PHP' },
  'kotlin': { port: 3018, name: 'kotlin-container-live', display: 'Kotlin' },
  'cpp': { port: 3019, name: 'cpp-container-live', display: 'C++' },
  'qsharp': { port: 3020, name: 'qsharp-container-live', display: 'Q#' },
  'elixir': { port: 3021, name: 'elixir-container-live', display: 'Elixir' },
  // Infrastructure / DevOps
  'helm': { port: 3022, name: 'helm-chart-container-live', display: 'Helm Chart' },
  // Special services
  'crud': { port: 3030, name: 'crud-service-universal', display: 'CRUD' }
};

/**
 * Get language/framework icon for preview tabs
 * @param {string} language - Detected language/framework
 * @param {number} containerPort - Container port to help determine framework
 * @returns {string} - Emoji icon for the language
 */
export const getLanguageIcon = (language, containerPort) => {
  const iconMap = {
    // Frontend
    3001: '⚛️',  // React
    3002: '▲',  // Next.js
    3003: '📱',  // React Native
    3004: '🅰️',  // Angular
    3005: '💚',  // Vue.js
    3006: '💙',  // jQuery
    3007: '🟣',  // ASP.NET Frontend
    3008: '🦖',  // Docusaurus
    // Backend
    3011: '🟢',  // Node.js
    3012: '🔵',  // Go
    3013: '🐍',  // Python
    3014: '☕',  // Java
    3015: '🟣',  // .NET
    3016: '🦀',  // Rust
    3017: '🐘',  // PHP
    3018: '🟣',  // Kotlin
    3019: '⚙️',  // C++
    3020: 'Q#',  // Q#
    3021: '💧',  // Elixir
    3022: '⎈',   // Helm Chart
    3030: '📊',  // CRUD
  };
  
  // Try to get icon by port first
  if (containerPort && iconMap[containerPort]) {
    return iconMap[containerPort];
  }
  
  // Fallback to language-based detection
  const languageIconMap = {
    'react': '⚛️',
    'nextjs': '▲',
    'reactnative': '📱',
    'angular': '🅰️',
    'vue': '💚',
    'jquery': '💙',
    'aspnet-frontend': '🟣',
    'docusaurus': '🦖',
    'node': '🟢',
    'go': '🔵',
    'python': '🐍',
    'java': '☕',
    'dotnet': '🟣',
    'rust': '🦀',
    'php': '🐘',
    'kotlin': '🟣',
    'cpp': '⚙️',
    'qsharp': 'Q#',
    'elixir': '💧',
    'helm': '⎈',
    'crud': '📊'
  };
  
  return languageIconMap[language] || '📦';
};
